<template>
  <a-switch
    v-bind="{ ...(antDesignProps || {}) }"
    :class="className"
    :checked="modelValue"
    :disabled="disabled"
    :name="name"
    :checkedChildren="labelChecked"
    :unCheckedChildren="labelUnchecked"
    @update:checked="toggle"
  />
</template>

<script>
import { isString, has, get } from './utils'

const DEFAULT_LABEL_CHECKED = 'on'
const DEFAULT_LABEL_UNCHECKED = 'off'

export default {
  name: 'ToggleButton',
  props: {
    modelValue: {
      type: [Number, Boolean],
      default: false
    },
    name: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String
    },
    sync: {
      type: Boolean,
      default: false
    },
    labels: {
      type: [Boolean, Object],
      default: () => false,
      validator(value) {
        return typeof value === 'object' ? value.checked || value.unchecked : typeof value === 'boolean'
      }
    },
    /**
     * Ant Design Props.
     */
    antDesignProps: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    className() {
      let { toggled, disabled } = this

      return [
        'switch',
        {
          toggled,
          disabled
        }
      ]
    },

    labelChecked() {
      return get(this.labels, 'checked', DEFAULT_LABEL_CHECKED)
    },

    labelUnchecked() {
      return get(this.labels, 'unchecked', DEFAULT_LABEL_UNCHECKED)
    }
  },
  watch: {
    modelValue(value) {
      if (this.sync) {
        this.toggled = !!value
      }
    }
  },
  data() {
    return {
      toggled: !!this.modelValue
    }
  },
  methods: {
    toggle(event) {
      const toggled = !this.toggled

      if (!this.sync) {
        this.toggled = toggled
      }

      this.$emit('update:modelValue', toggled)
      this.$emit('change', {
        value: toggled,
        tag: this.tag,
        srcEvent: event
      })
    }
  }
}
</script>

<style lang="postcss" scoped></style>
